<template>
    <div class="col-12 form-group">
        <label :for="customRef">Files</label>
        <vue-dropzone
            :id="customRef"
            :ref="customRef"
            class="h-100 d-flex justify-content-center align-items-center flex-wrap"
            :options="multiDropzoneOptions"
            @vdropzone-success-multiple="onSuccess"
            @vdropzone-files-added="onFilesChange"
            @vdropzone-removed-file="onFilesChange"
            @vdropzone-canceled="isUploading = false"
        />
        <div class="d-flex justify-content-center mt-2">
            <button
                class="btn btn-success waves-effect waves-light"
                data-animation="fadein"
                data-overlaycolor="#38414a"
                :disabled="isUploading || !filesAdded"
                @click="uploadImages"
            >
                <span v-if="isUploading" class="spinner" />
                <span v-else> Upload files </span>
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import vue2Dropzone from 'vue2-dropzone';
import { apiUrl } from '@/config';

export default {
    components: {
        vueDropzone: vue2Dropzone
    },

    props: {
        refProps: {
            type: String,
            required: false,
            default: ''
        },
        type: {
            type: String,
            required: false,
            default: ''
        }
    },

    data() {
        return {
            dropzoneRelativePath: '/admin/media',
            isUploading: false,
            filesAdded: false
        };
    },

    computed: {
        ...mapGetters({
            loggedUser: 'auth/loggedUser'
        }),

        acceptedFiles() {
            const typeToFiles = {
                image: 'image/*',
                video: 'video/*',
                audio: 'audio/*',
                text: 'text/*,.rtf',
                pdf: 'application/pdf',
                doc: '.doc,.docx',
                ppt: '.ppt,.pptx',
                archive: '.bz,.bz2,.rar,.gz,.tar,.7z,.zip'
            };

            if (this.type) {
                return typeToFiles[this.type];
            }

            return Object.values(typeToFiles).join(',');
        },

        multiDropzoneOptions() {
            const options = {
                timeout: null,
                url: apiUrl + this.dropzoneRelativePath,
                thumbnailWidth: 150,
                maxFilesize: 1000,
                parallelUploads: 100,
                uploadMultiple: true,
                acceptedFiles: this.acceptedFiles,
                dictDefaultMessage: "Upload New Files <i class='fe-upload'/>",
                addRemoveLinks: true,
                duplicateCheck: true,
                withCredentials: true,
                autoProcessQueue: false,
                headers: { cluid: this.loggedUser.id }
            };

            return options;
        },

        customRef() {
            if (this.refProps) {
                return this.refProps;
            }

            return (
                Math.random()
                    .toString(36)
                    .substring(2, 30)
                    .match(/[a-zA-Z]+/g)
                    .join('') + 'ImageDropzone'
            );
        }
    },

    methods: {
        uploadImages() {
            this.isUploading = true;

            this.$refs[this.customRef].dropzone.files.forEach(
                file => (file.status = 'queued')
            );

            this.$refs[this.customRef].processQueue();
        },

        onSuccess(files, response) {
            this.isUploading = false;

            this.$toaster('Files have been uploaded.');

            this.$emit('uploaded', response);

            this.$refs[this.customRef].removeAllFiles();
        },

        async onFilesChange() {
            await this.$nextTick();

            this.filesAdded = !!this.$refs[this.customRef].dropzone.files
                .length;

            this.isUploading = false;
        }
    }
};
</script>
